export class MCHAvailableProductLine {
    public PlantId: number;
    public PlantNumber: number;
    public PlantDescription: string;
    public ProductLineCode: string;
    public ProductLineCodeDescription: string;
    public BAQAvailable: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/mchavailableproductline.ts